<app-deliverables-list
  [data$]="data$"
  [displayedColumns]="displayedColumns"
  [curveProfiles]="curveProfiles$ | async"
  [projectId]="projectId"
  (navigateToDeliverable)="navigateToDeliverable($event)"
  (navigateToPackage)="navigateToPackage($event)"
></app-deliverables-list>
